import { gql } from '@apollo/client';

export * from './assetCreateCustom.mutation.generated';

export const ASSET_CREATE_CUSTOM = gql`
  mutation assetCreateCustom($assetsParams: [AssetCreateCustomParams!]!, $softwareEscrowId: ID!, $integrationId: ID!) {
    assetCreateCustom(
      input: { assetsParams: $assetsParams, softwareEscrowId: $softwareEscrowId, integrationId: $integrationId }
    ) {
      success
      errors
      assets {
        id
        depositStatus
        depositMethod
        depositSource
        softwareEscrow {
          id
          status
        }
      }
    }
  }
`;
